import React from 'react';
import classNames from 'classnames';
import teachOnly from '../../../../assets/svgs/banner_grey_horizontal.svg.js';
import lock from '../../../../assets/svgs/lock.svg.js';
import styles from './BoardworksTeachOnly.scss.js';
import { useCustomTranslation } from '../../../../hooks/useCustomTranslation/useCustomTranslation.js';

const BoardworksTeachOnly = () => {
  const {
    tCustom
  } = useCustomTranslation();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.modal__content
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundImage: `url("${teachOnly}")`
    },
    className: styles.modal__content__banner
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.modal__content__banner__img,
    src: lock,
    alt: "lock icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.modal__content__banner__text
  }, tCustom('MODAL_TEACH_ONLY_TITLE'))), /*#__PURE__*/React.createElement("div", {
    className: styles.modal__content__description
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.modal__content__description__title])
  }, tCustom('BOARDWORKS_BLOCKED_MODAL_TITLE')), /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.modal__content__description__description])
  }, tCustom('BOARDWORKS_BLOCKED_MODAL_DESCRIPTION')))));
};
var BoardworksTeachOnly$1 = BoardworksTeachOnly;

export { BoardworksTeachOnly$1 as default };
//# sourceMappingURL=BoardworksTeachOnly.js.map
